module.exports = __webpack_public_path__ + "static/media/background_pattern.8d5f2c68.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/background_pattern.png
// module id = 753
// module chunks = 0